import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Breadcrumb } from '../../models/breadcrumb.model';

@Component({
  selector: 'ggi-journey-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent {
  @Input() breadcrumb: Breadcrumb[] = [];

  constructor(private readonly router: Router) {}

  public goToRoute(url: string): void {
    if (url) {
      if (url === this.router.url) {
        location.reload();
      } else {
        this.router.navigateByUrl(url);
      }
    }
  }
}
